import { v4 as uuidv4 } from 'uuid';
// eslint-disable-next-line import/named
import { postMatomo } from './api';

/* eslint-disable */

const userLocalStorage = localStorage.getItem('userInfo');
const userInfo = JSON.parse(userLocalStorage || '{}');

const settingsMatomo = {
  rec: 1,
  uid: userInfo.fullname || '',
  // uid: 'id' in userInfo ? userInfo.id : -1,
  res: `${window.screen.width}x${window.screen.height}`,
  send_image: 0
};
const configHeadersMatomo = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
  }
};

/**
 * собираем строку для отправки постом
 * @param payload
 * @returns {string|*[]}
 */
function createPayloadAsUrl(payload) {
  if (!payload) return [];
  // eslint-disable-next-line camelcase
  const payload_url = [];
  // eslint-disable-next-line
  for (let property in payload) {
    // eslint-disable-next-line
    payload_url.push(encodeURIComponent(property) + '=' + encodeURIComponent(
      typeof payload[property] === 'object' ?
        JSON.stringify(payload[property]) : payload[property])
    );
  }
  return payload_url.join('&');
}

/**
 * Функция для определения стенда
 * */
function serverInit() {
  // if (document.location.hostname.indexOf('192.168') >= 0) {
  //   return {
  //     MATOMO_SERVER_IDSITE: 2,
  //     MATOMO_SERVER_HOST: 'https://mes-matomo.kube.severstal.severstalgroup.com'
  //   };
  // }
  if (document.location.hostname.indexOf('mesus.mobileapp.severstal') >= 0) {
    return {
      MATOMO_SERVER_IDSITE: 1,
      MATOMO_SERVER_HOST: 'https://us-trace.severstal.severstalgroup.com'
    };
  }
  if (document.location.hostname.indexOf('mesus-test.mobileapp.severstal') >= 0) {
    return {
      MATOMO_SERVER_IDSITE: 2,
      MATOMO_SERVER_HOST: 'https://us-trace.severstal.severstalgroup.com'
    };
  }
  if (document.location.hostname.indexOf('mesus-dev.mobileapp.severstal') >= 0) {
    return {
      MATOMO_SERVER_IDSITE: 3,
      MATOMO_SERVER_HOST: 'https://us-trace.severstal.severstalgroup.com'
    };
  }
  if (document.location.hostname.indexOf('mesus-test.kube.severstal.severstalgroup') >= 0) {
    return {
      MATOMO_SERVER_IDSITE: 12,
      MATOMO_SERVER_HOST: 'https://mes-matomo.kube.severstal.severstalgroup.com'
    };
  }
  if (document.location.hostname.indexOf('mesus.kube.severstal.severstalgroup') >= 0) {
    return {
      MATOMO_SERVER_IDSITE: 13,
      MATOMO_SERVER_HOST: 'https://mes-matomo.kube.severstal.severstalgroup.com'
    };
  }
  if (document.location.hostname.indexOf('mesus-dev.kube.severstal.severstalgroup') >= 0) {
    return {
      MATOMO_SERVER_IDSITE: 14,
      MATOMO_SERVER_HOST: 'https://mes-matomo.kube.severstal.severstalgroup.com'
    };
  }
  return {
    MATOMO_SERVER_IDSITE: null,
    MATOMO_SERVER_HOST: null
  };
}

/**
 * Отправка данных в сервис аналитики Matomo
 * @param data
 * @returns {Promise<void>}
 */
const trackToMatomo = async (data) => {
  const matomoOptions = serverInit();
  if (!matomoOptions || !matomoOptions.MATOMO_SERVER_IDSITE || !matomoOptions.MATOMO_SERVER_HOST) return;

  const now = new Date();
  let payload = {
    idsite: matomoOptions.MATOMO_SERVER_IDSITE,
    ...settingsMatomo,
    ...data,
    url: window.location.href,
    h: now.getHours(),
    m: now.getMinutes(),
    s: now.getSeconds()
  };
  const prefomanceTiming = performanceMetrics();
  if (prefomanceTiming) {
    Object.keys(prefomanceTiming)
      .forEach((key) => {
        payload[key] = prefomanceTiming[key];
      });
  }
  try {
    await postMatomo(`${matomoOptions.MATOMO_SERVER_HOST}/matomo.php`, createPayloadAsUrl(payload), configHeadersMatomo);
  } catch (e) {

  }
};

/**
 * Отправка статистики после загрузки страницы
 * @param documentTitle
 */
export const matomoPageView = (documentTitle = window.document.title) => {
  const pv_id = uuidv4()
    .replaceAll('-', '')
    .slice(0, 6);
  window.pv_id = pv_id;

  let payload = {
    action_name: documentTitle,
    pv_id: pv_id
  };
  trackToMatomo(payload)
    .then(r => {
    });
};

/**
 * send statistic for event of DOM items
 * @param data
 */
export const matomoEventSend = (data, func = () => {}) => {
  let payload = {
    e_c: data.category,
    e_a: data.action,
    e_n: data.name_ru || '',
    e_v: data.value || '',
    _cvar: data.data,
    ca: 1,
    pv_id: window.pv_id
  };

  if (data.name_en) {
    payload = Object.assign(payload, {
      customDimensions: {
        id: 1,
        value: data.name_en
      }
    });
  }
  trackToMatomo(payload)
    .then(r => {
      func();
    });
};

/**
 * вычисление времени выполнения скрипта\загрузки страницы
 * @returns {{}|null}
 */
export const performanceMetrics = () => {
  /* performance timing */
  const performanceAlias = window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance;

  let timing = {};
  if (!performanceAlias) {
    return null;
  }
  let performanceData = (typeof performanceAlias.timing === 'object') && performanceAlias.timing ? performanceAlias.timing : undefined;

  if (!performanceData) {
    performanceData = (typeof performanceAlias.getEntriesByType === 'function') && performanceAlias.getEntriesByType('navigation') ? performanceAlias.getEntriesByType('navigation')[0] : undefined;
  }

  if (!performanceData) {
    return null;
  }

  if (performanceData.connectEnd && performanceData.fetchStart) {
    if (performanceData.connectEnd < performanceData.fetchStart) {
      return null;
    }
    // How long it took to connect to server
    timing['pf_net'] = Math.round(performanceData.connectEnd - performanceData.fetchStart);
  }

  if (performanceData.responseStart && performanceData.requestStart) {
    if (performanceData.responseStart < performanceData.requestStart) {
      return null;
    }
    // How long it took the server to generate page.
    timing['pf_srv'] = Math.round(performanceData.responseStart - performanceData.requestStart);
  }

  if (performanceData.responseStart && performanceData.responseEnd) {
    if (performanceData.responseEnd < performanceData.responseStart) {
      return null;
    }
    // How long it takes the browser to download the response from the server
    timing['pf_tfr'] = Math.round(performanceData.responseEnd - performanceData.responseStart);
  }

  if (typeof performanceData.domLoading !== 'undefined') {
    if (performanceData.domInteractive && performanceData.domLoading) {

      if (performanceData.domInteractive < performanceData.domLoading) {
        return null;
      }

      timing['pf_dm1'] = Math.round(performanceData.domInteractive - performanceData.domLoading);
    }
  } else {
    if (performanceData.domInteractive && performanceData.responseEnd) {

      if (performanceData.domInteractive < performanceData.responseEnd) {
        return null;
      }

      timing['pf_dm1'] = Math.round(performanceData.domInteractive - performanceData.responseEnd);
    }
  }

  if (performanceData.domComplete && performanceData.domInteractive) {
    if (performanceData.domComplete < performanceData.domInteractive) {
      return null;
    }
    // How long it takes for the browser to load media and execute any Javascript code listening for the DOMContentLoaded event.
    timing['pf_dm2'] = Math.round(performanceData.domComplete - performanceData.domInteractive);
  }

  if (performanceData.loadEventEnd && performanceData.loadEventStart) {
    if (performanceData.loadEventEnd < performanceData.loadEventStart) {
      return null;
    }
    // How long it takes the browser to execute Javascript code waiting for the window.load event.
    timing['pf_onl'] = Math.round(performanceData.loadEventEnd - performanceData.loadEventStart);
  }

  return timing;
};
/* eslint-enable */
